var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"close",on:{"click":_vm.hideTab}},[_c('img',{attrs:{"src":"http://litiresource.xcgogo.site/user/6403275/images/e111cdd93a251a51368868ca00c0de46.png"}})])}
var staticRenderFns = []

export { render, staticRenderFns }